import { useMutation, useQueryClient } from "@tanstack/react-query";
import { FC } from "react";

import { editCreditEvaluationIncome } from "api/creditEvaluations";
import { creditEvaluationsKeys } from "api/creditEvaluations/queries";
import { CreditEvaluationIncome } from "api/creditEvaluations/types";
import AppDialog from "components/AppDialog";
import ModalHeader from "components/AppDialog/ModalHeader";

import IncomeForm, { IncomeFormValues } from "./IncomeForm";

interface EditIncomeModalProps {
  creditEvaluationId: string;
  isOpen: boolean;
  handleClose: () => void;
  context: CreditEvaluationIncome | undefined;
}

const EditIncomeModal: FC<EditIncomeModalProps> = ({
  creditEvaluationId,
  isOpen,
  handleClose,
  context,
}) => {
  const queryClient = useQueryClient();

  const initialValues: IncomeFormValues = {
    _id: context?._id || "",
    type: context?.type || "",
    period: context?.period || "",
    source: context?.source || "",
    incomes:
      context?.incomeSources.map((incomeSource) => ({
        // @ts-expect-error
        _id: incomeSource._id || null,
        date: incomeSource.date || null,
        amount: incomeSource.amount || null,
        ytd: incomeSource.ytd || null,
        grossRevenue: incomeSource.grossRevenue || null,
        netProfit: incomeSource.netProfit || null,
        annualWages: incomeSource.annualWages || null,
        source: incomeSource.source || "",
        monthlyBenefit: incomeSource.monthlyBenefit || null,
      })) || [],
  };

  const { mutateAsync: editIncome, status } = useMutation(async (data: any) => {
    const res = await editCreditEvaluationIncome(
      creditEvaluationId,
      data._id,
      data,
    );
    await queryClient.invalidateQueries(
      creditEvaluationsKeys.details(creditEvaluationId),
    );

    return res.data;
  });

  const handleSubmit = async (values: IncomeFormValues) => {
    const mappedValues: any = {
      ...values,
    };

    await editIncome(mappedValues, {
      onSuccess: () => handleClose(),
    });
  };

  return (
    <AppDialog open={isOpen} onClose={handleClose} maxWidth="md">
      <ModalHeader
        title="Edit Income"
        subtitle="Update income source details."
      />
      <IncomeForm
        handleSubmit={handleSubmit}
        handleClose={handleClose}
        submitStatus={status}
        initialValues={initialValues}
      />
    </AppDialog>
  );
};

export default EditIncomeModal;
